import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { OnRampPurchaseStatus } from '@usecapsule/web-sdk';
import { CreationStepSubheading, Heading, SpinnerContainer } from '../common.js';
import { ON_RAMP_PROVIDERS } from '../../constants/constants.js';
import { useModalStore } from '../../stores/index.js';
import { CpslSpinner } from '@usecapsule/react-components';
export const AddingFunds = () => {
    const onRampPurchase = useModalStore(state => state.onRampPurchase);
    return (_jsxs(_Fragment, { children: [_jsx(SpinnerContainer, { children: _jsx(CpslSpinner, {}) }), _jsx(Heading, { children: _jsx("span", { children: "Adding Funds..." }) }), _jsx(CreationStepSubheading, { children: _jsxs("span", { children: ["Follow the prompts presented by", ' ', OnRampPurchaseStatus ? ON_RAMP_PROVIDERS[onRampPurchase.provider].name : 'the provider', "."] }) })] }));
};
